import { createSlice } from "@reduxjs/toolkit";

// Create a slice for categories
const distributorSlice = createSlice({
  name: "distributor",
  initialState: {
    distributorItems: [],
    distributor: {},
    loading: false,
    error: null,
  },
  reducers: {
    setDistributorItems: (state, action) => {
      state.distributorItems = action.payload.data || [];
      state.loading = false;
    },
    setDistributor: (state, action) => {
      state.distributor = action.payload.data || [];
      state.loading = false;
    },
  },
});

// Export the loading and error selectors if needed
export const selectDistributorLoading = (state) => state.distributor.loading;
export const selectDistributorError = (state) => state.distributor.error;
export const selectDistributorItems = (state) => state.distributor.distributorItems;
export const selectDistributor = (state) => state.distributor.distributor;

// Export the reducer to include in the store
export const { setDistributor, setDistributorItems } = distributorSlice.actions;
export default distributorSlice.reducer;
